import { createContext, Dispatch } from 'react'
import { Action, State } from './types'

interface ViewContextProps extends State {
  dispatch: Dispatch<Action>
}

const ViewContext = createContext<ViewContextProps>({
  layers: {
    others: true,
    pattern: false,
    warehouses: true,
    borderPoints: false,
  },
  dispatch: (_: Action) => null
})

export default ViewContext